<!-- 
New Data from viewer dialiog v3
This dialog viewer is embedded with the form viewer
-->
<template>
  <div class="formViewer">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <div class="headline">{{formName}}</div>
        <v-spacer></v-spacer>

        <!--- search controls --->
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <!-- inside control -->
              <v-layout wrap>
                <v-flex xs12 sm3 md2>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        label="start date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>

                  <v-menu
                    ref="endDatemenu"
                    v-model="endDatemenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="selectedendDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="selectedendDate"
                        label="end date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="selectedendDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="endDatemenu = false">Cancel</v-btn>
                      <v-btn
                        flat
                        color="primary"
                        @click="$refs.endDatemenu.save(selectedendDate)"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm3 md2>
                  <v-select
                    v-model="selectedCity"
                    item-text="city"
                    :items="citySelectList"
                    label="city"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm3 md2>
                  <v-select
                    v-model="selectedState"
                    item-text="state"
                    :items="stateSelectList"
                    label="state"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm3 md2>
                  <v-select
                    v-model="selectedBranch"
                    item-text="branch"
                    :items="branchSelectList"
                    label="branch"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm3 md2>
                  <v-select
                    v-model="selectedUser"
                    item-text="userName"
                    :items="userSelectList"
                    label="user Name"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm3 md2>
                  <v-btn
                    mt-10
                    :loading="searchLoading"
                    :disabled="searchLoading"
                    color="secondary"
                    @click="loadTableRecords()"
                  >Search</v-btn>
                  <v-btn
                    mt-10
                    :loading="searchLoading"
                    :disabled="searchLoading"
                    color="secondary"
                    @click="exportCsv()"
                  >Export to csv</v-btn>
                </v-flex>
              </v-layout>
              <!-- inside controls end -->
            </v-card-text>
          </v-card>
        </v-flex>

        <!-- search control end -->

        <!-- table -->
        <v-flex lg12>
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="fromsResults"
            :total-items="total_items"
            class="elevation-1"
            v-on:update:pagination="paginationHandler"
            :rows-per-page-items="[50]"
          >
            <template v-slot:no-data>
              <v-alert :value="true" color="error" icon="warning">Sorry, nothing to display here :(</v-alert>
            </template>

            <!-- Generate table data based on the header column -->
            <template v-slot:items="props">
              <template v-for="(item, index) in headers">
                <td
                  v-if="item.value != 'action'"
                  v-bind:key="item.value"
                  class="text-xs-center text-ms-center"
                >{{ props.item[''+item.value]}}</td>

                <td
                  v-if="item.value == 'action'"
                  class="justify-center layout px-0"
                  v-bind:key="item.value"
                >
                  <v-btn round small color="primary" @click="showDataViewerDialog(props)">view</v-btn>
                </td>
              </template>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- view show dialog -->
    <v-dialog v-model="isDataViewerDialigVisible" scrollable>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="closeDataViewerDialog()">Close</v-btn>
        </v-card-title>

        <v-card-text>
          <div id="surveyContainer">
            <survey :survey="surveyModel"></survey>
          </div>
        </v-card-text>

        <!-- <v-divider></v-divider> -->

        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="closeDataViewerDialog()">Close</v-btn>
        </v-card-actions>-->
      </v-card>
    </v-dialog>

    <!--- CSV process dialig --->
    <v-dialog v-model="csvdialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <div>Please wait while csv is generated</div>
          {{csvDialogMsg}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          <div class="text-md-center" v-if="csvProcressingCompleted">
            <v-btn :href="csvDownloadUrl" download="exporteddata.csv" color="green">Download</v-btn>
            <v-btn color="red" @click="()=>{csvdialog=false;}">Close</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import addDialogSurvey from "../components/FormViewerSurveyDialog.vue";
import DataFormViewerDialog from "../components/DataFormViewerDialog.vue";

import config from "../config.js";
const serverHost = config.backendServerHost;

import * as SurveyVue from "survey-vue";
import "bootstrap/dist/css/bootstrap.css";
var Survey = SurveyVue.Survey;
Survey.cssType = "material";
import * as widgets from "surveyjs-widgets";
import droid from "../droidimagepicker.js";
import droidLocation from "../droidlocationpicker.js";

import "inputmask/dist/inputmask/phone-codes/phone.js";
widgets.icheck(SurveyVue);
widgets.select2(SurveyVue);
widgets.inputmask(SurveyVue);
widgets.jquerybarrating(SurveyVue);
widgets.jqueryuidatepicker(SurveyVue);
widgets.nouislider(SurveyVue);
widgets.select2tagbox(SurveyVue);
widgets.signaturepad(SurveyVue);
widgets.sortablejs(SurveyVue);
widgets.ckeditor(SurveyVue);
widgets.autocomplete(SurveyVue);
widgets.bootstrapslider(SurveyVue);
droid(SurveyVue);
droidLocation(SurveyVue);

export default {
  data() {
    return {
      surveyModel: {},
      currentDataViewerFormResult: {},
      isDataViewerDialigVisible: false,
      formSchema: [],
      loading: true,
      headers: [
        {
          text: "Submited Date",
          align: "center",
          sortable: true,
          value: "createdDate"
        },
        { text: "submited by", align: "center", value: "userName" },
        { text: "state", align: "center", value: "state" },
        { text: "city", align: "center", value: "city" },
        { text: "branch", align: "center", value: "branch" },
        { text: "Actions", align: "center", value: "action", sortable: false }
      ],
      fromsResults: [],
      formName: "Form Name",
      date: new Date().toISOString().substr(0, 10),
      selectedendDate: new Date().toISOString().substr(0, 10),
      menu: false,
      endDatemenu: false,
      citySelectList: [],
      userSelectList: [],
      stateSelectList: [],
      branchSelectList: [],
      selectedCity: "ALL",
      selectedState: "ALL",
      selectedBranch: "ALL",
      selectedUser: "ALL",
      searchLoading: false,
      totalRecords: 0,
      limit: 1000,
      page: 0,
      hasNext: false,
      csvdialog: false,
      csvDialogMsg: "processing",
      csvDownloadUrl: "",
      csvProcressingCompleted: false,
      total_items:0
    };
  },
  mounted() {
    console.log("DataFormViewer mounted");
    this.loadFormSchema();
    this.loadSearchingData();
    this.loadTableRecords();
  },
  components: {
    addDialogSurvey,
    DataFormViewerDialog,
    Survey
  },
  methods: {
    paginationHandler(value) {
      //console.log("pagination " + JSON.stringify(value));
      if (this.hasNext) {
        this.page++;
        this.loadTableRecords();
      }
    },
    onClickChild(value) {
      console.log(value); // someValue
      //alert(JSON.stringify(value));
      this.userData.push(JSON.parse(value));
    },
    deleteItem(value) {
      this.userData.pop(value);
    },

    loadTableRecords() {
      this.loading = true;
      var path = this.$route.query.test;

      var formToFetch = {
        formCode: "" + path,
        pageno: this.page,
        limit: this.limit,
        city: this.selectedCity,
        user: this.selectedUser,
        state: this.selectedState,
        branch: this.selectedBranch,
        startDate: this.date,
        endDate: this.selectedendDate
      };
      //send request
      this.$axios
        .post(serverHost + "/ResultProvider/get", JSON.stringify(formToFetch))
        .then(response => {
          //console.log(response);

          if (response.status == 200) {
            console.log("responseLength : " + response.data.data.length);
            //append to data array
            //extract the total records
            this.totalRecords = response.data.totalRecords;
            this.hasNext = response.data.hasNext;
            this.fromsResults = [];
            for (
              var arIndex = 0;
              arIndex < response.data.data.length;
              arIndex++
            ) {
              //console.log("created date " + response.data.data[arIndex]._created_at );
              //patch the date
              //new Date().toISOString().substr(0, 10)
              var singleRecord = {
                //createdDate: new Date(response.data.data[arIndex].createdAt), //no conversion needed
                createdDate: response.data.data[arIndex].entryDate,
                // new Date(response.data.data[arIndex]._created_at)
                //   .toISOString()
                //   .substr(0, 10),
                userName: response.data.data[arIndex].userName,
                city: response.data.data[arIndex].city,
                branch: response.data.data[arIndex].branch,
                state: response.data.data[arIndex].state,
                result: JSON.parse(response.data.data[arIndex].result)
              };

              this.fromsResults.push(singleRecord);
              // console.log("dataFromResponse : "+response.data.docs[arIndex]);
            }

            //set pagination totalItems
            this.total_items=response.data.totalRecords;
         
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    loadFormSchema() {
      var path = this.$route.query.test;
      console.log("route : " + path);

      var formToFetch = { formCode: "" + path };
      //send request
      this.$axios
        .get(serverHost + "/schemas/getFormSchema/" + path)
        .then(response => {
          //console.log(response);

          if (response.status == 200) {
            console.log(
              "formSchema : " + JSON.stringify(response.data[0].formSchema)
            );

            var parsedFormSchema = JSON.parse(response.data[0].formSchema);
            console.log(
              "parsed form schema " + JSON.stringify(parsedFormSchema)
            );

            this.formName = response.data[0].formName;
            console.log("form name :" + this.formName);

            //append to data array
            var surveyQuestionModel = new SurveyVue.Model(parsedFormSchema);

            //set the surveymode
            this.surveyModel = surveyQuestionModel;

            this.formSchema = surveyQuestionModel.getAllQuestions();
            console.log(
              "found questions " +
                this.formSchema.length +
                " " +
                JSON.stringify(this.formSchema)
            );
            //form loaded now extract the question from it

            this.loading = false;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    showDataViewerDialog(value) {
      console.log("prop " + JSON.stringify(value));
      this.currentDataViewerFormResult = value;
      this.isDataViewerDialigVisible = true;
      this.surveyModel.currentPageNo = 0;
      this.surveyModel.mode = "display";
      this.surveyModel.data = value.item.result;
    },
    closeDataViewerDialog() {
      this.currentDataViewerFormResult = {};
      this.isDataViewerDialigVisible = false;
      this.surveyModel.clear();
    },

    getTheResultValue: function(questionName) {
      try {
        console.log("==> " + questionName);
        return this.currentDataViewerFormResult.item.result["" + questionName];
      } catch (err) {
        return "";
      }
    },
    getImagePath: function(value) {
      return serverHost + "/img/";
    },
    loadSearchingData: function() {
      // Make a request for a user with a given ID
      this.$axios
        .get(serverHost + "/filters/get")
        .then(response => {
          if (response.status == 200) {
            this.citySelectList = response.data.city;
            this.branchSelectList = response.data.branch;
            this.userSelectList = response.data.userName;
            this.stateSelectList = response.data.state;

            //append ALL to each array
            this.citySelectList.unshift("ALL");
            this.branchSelectList.unshift("ALL");
            this.userSelectList.unshift("ALL");
            this.stateSelectList.unshift("ALL");
          }
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        })
        .finally(function() {
          // always executed
        });
    },
    exportCsv: async function() {
      this.csvdialog = true;
      this.csvProcressingCompleted = false;
      //fetch all the records
      var recordsLeft = true;
      var processPage = 0;
      var csv = "";

      for (var i = 0; i < this.formSchema.length; i++) {
        csv += "" + this.formSchema[i].name + ",";
      }
      csv += "\r\n";

      while (recordsLeft) {
        var path = this.$route.query.test;

        var formToFetch = {
          formCode: "" + path,
          pageno: processPage,
          limit: 1000,
          city: this.selectedCity,
          user: this.selectedUser,
          state: this.selectedState,
          branch: this.selectedBranch,
          startDate: this.date,
          endDate: this.selectedendDate
        };

        const response = await this.$axios.post(
          serverHost + "/resultProvider/get",
          JSON.stringify(formToFetch)
        );
        if (response.status == 200) {
          var parsedData = 
          recordsLeft = response.data.hasNext;
          console.log(response.data.data.length +" => "+ response.data.hasNext+" => "+response.data.totalRecords);
          processPage++;

          for (
            var arIndex = 0;
            arIndex < response.data.data.length;
            arIndex++
          ) {
            this.csvDialogMsg = "Processing " + processPage + "/" + arIndex;
            for (var i = 0; i < this.formSchema.length; i++) {
              csv +=
                '"' +
                JSON.parse(response.data.data[arIndex].result)[
                  "" + this.formSchema[i].name
                ] +
                '",';
            }
            csv += "\r\n";
          }
        }
      }

      this.csvDialogMsg = "Processing completed click download";
      this.csvProcressingCompleted = true;
      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      var url = URL.createObjectURL(blob);
      var link = document.createElement("a");
      this.csvDownloadUrl = url;
      link.setAttribute("href", url);
      link.setAttribute("download", "exporteddata.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style>
.gmap3 {
  margin: 20px auto;
  border: 1px dashed #c0c0c0;
  width: 200;
  height: 400px;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>